module.exports = new __parcel__URL__("Project Plan Hover.48617613.svg").toString();